<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
<main class="container py-4">

  <div class="mb-4">
    <h4 class="fw-bold mb-1">Compliance Setup Guide</h4>
    <div class="text-muted small">
      Follow this order to configure jurisdictions, tiers, limits and dynamic KYC UI successfully.
    </div>
  </div>

  <div class="alert alert-info shadow-sm border-0">
    <div class="fw-semibold mb-1">Recommended Setup Order</div>
    <div class="small">
      Start with jurisdictions, then create tiers, configure tier limits, create policies, and finally add fields, documents and rules.
      This ensures the user-facing verification flow is built on complete admin configuration.
    </div>
  </div>

  <div class="row g-4 mb-4">
    <div class="col-md-4" *ngFor="let item of quickLinks">
      <div class="card shadow-sm border-0 h-100">
        <div class="card-body d-flex flex-column">
          <h5 class="mb-2">{{ item.title }}</h5>
          <div class="text-muted small flex-grow-1">
            Open the {{ item.title.toLowerCase() }} admin area.
          </div>
          <a class="btn btn-outline-primary btn-sm mt-3" [routerLink]="item.route">
            Open {{ item.title }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm border-0">
    <div class="card-body">
      <h5 class="mb-3">Setup Checklist</h5>

      <div class="timeline-guide">
        <div class="guide-step border rounded-3 p-3 mb-3 bg-white" *ngFor="let item of steps">
          <div class="d-flex flex-wrap justify-content-between align-items-start gap-3">
            <div class="d-flex gap-3">
              <div class="step-badge rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
                {{ item.step }}
              </div>

              <div>
                <div class="fw-semibold">{{ item.title }}</div>
                <div class="text-muted small mt-1">
                  {{ item.description }}
                </div>
              </div>
            </div>

            <div>
              <a class="btn btn-primary btn-sm" [routerLink]="item.route">
                {{ item.button }}
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="card shadow-sm border-0 mt-4">
    <div class="card-body">
      <h5 class="mb-3">What Each Section Controls</h5>

      <div class="row g-3 small">
        <div class="col-md-4">
          <div class="border rounded-3 p-3 h-100">
            <div class="fw-semibold mb-2">Jurisdictions</div>
            <div class="text-muted">
              Controls country or fallback jurisdiction setup used across tiers and policies.
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="border rounded-3 p-3 h-100">
            <div class="fw-semibold mb-2">Tiers & Limits</div>
            <div class="text-muted">
              Controls the user’s allowed activity, transaction thresholds and financial limits.
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="border rounded-3 p-3 h-100">
            <div class="fw-semibold mb-2">Policies</div>
            <div class="text-muted">
              Controls the actual KYC experience users see: fields, document requirements and rule logic.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</main>
</div>